export function PersonalDocument(personalDocument: string) {
  const masked = applyMask(personalDocument);
  const unmasked = removeMask(personalDocument);
  const isValid = validate(personalDocument);
  const isEmpty = hasNoValue(personalDocument);
  const isPersonalDocument = isPersonalDocumentCheck(personalDocument);

  return {
    masked,
    unmasked,
    isValid,
    isEmpty,
    isPersonalDocument,
  };
}

function validate(document: string) {
  if (hasNoValue(document))
    return true;

  const cpf: string = removeMask(document);
  let sum = 0;
  let rest = 0;

  if (checkLength(cpf))
    return false;

  if (checkDigits(cpf))
    return false;

  for (let i = 1; i <= 9; i++)
    sum = sum + Number.parseInt(cpf.substring(i - 1, i)) * (11 - i);

  rest = (sum * 10) % 11;

  if (rest === 10 || rest === 11)
    rest = 0;
  if (rest !== Number.parseInt(cpf.substring(9, 10)))
    return false;

  sum = 0;
  for (let i = 1; i <= 10; i++)
    sum = sum + Number.parseInt(cpf.substring(i - 1, i)) * (12 - i);

  rest = (sum * 10) % 11;

  if (rest === 10 || rest === 11)
    rest = 0;
  if (rest !== Number.parseInt(cpf.substring(10, 11)))
    return false;

  return true;
};

function removeMask(document: string): string {
  return !document
    ? ''
    : document.replace(/\D/g, '');
}

function applyMask(document: string): string {
  return !document
    ? ''
    : document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

function checkLength(document: string): boolean {
  return document.length !== 11;
}

function checkDigits(document: string) {
  const invalid = [
    '00000000000',
    '11111111111',
    '22222222222',
    '33333333333',
    '44444444444',
    '55555555555',
    '66666666666',
    '77777777777',
    '88888888888',
    '99999999999',
  ];

  return invalid.find(data => data === document);
}

function hasNoValue(document: string) {
  return !document || document === '';
}

function isPersonalDocumentCheck(document: string): boolean {
  return hasNoValue(document)
    ? false
    : !checkLength(removeMask(document));
}
